import { z } from 'zod'
import * as http from '@/util/http'
import { type ProgressFlag, saveProgress } from '@/util/progress'
import { fetchProgressFlags } from '@/util/progress'
import { queryClient } from '@/util/queryClient'

export const InterestSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  emoji: z.string().optional(),
})

export type Interest = z.infer<typeof InterestSchema>

export async function fetchUserInterests(): Promise<Interest[]> {
  const { data } = await http.get<Interest[]>('/api/v1/user/profile/interest')
  return data
}

export async function syncInterests(interestIds: number[]) {
  await http.put('/api/v1/user/profile/interest', {
    payload: interestIds,
  })
}

export async function syncProgress(flags: ProgressFlag, syncDb: boolean = true) {
  const previousFlags = await queryClient.ensureQueryData<ProgressFlag>({
    queryKey: ['progress-flags'],
    queryFn: fetchProgressFlags,
    staleTime: Infinity,
  })

  try {
    if (syncDb) {
      await saveProgress(flags)
    }
    queryClient.setQueryData(['progress-flags'], () => previousFlags | flags)
  } catch (err) {
    console.log(err)
  }
}
